package com.merkost.handpass.api.dto.waitlist

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class WaitlistStatus {
    @SerialName("accepted")
    ACCEPTED,

    @SerialName("already_subscribed")
    ALREADY_SUBSCRIBED,
}
